import { Component, OnInit } from '@angular/core';
import { EquipmentService, TicketsService ,MessageService} from 'src/app/services'
import { CreateTicketFormFields,SaveBatchTicket } from 'src/app/models/tickets/createTicketFormFields';
@Component({
  selector: 'bart-batch-ticket-info',
  templateUrl: './batch-ticket-info.component.html',
  styleUrls: ['./batch-ticket-info.component.scss']
})
export class BatchTicketInfoComponent implements OnInit {
  FacilityEquipmentData: any[] = [];
  FacilityEquipmentColumns: any[];
  selectedColumns: any[];
  selectedData?: any[] = [];
  public formFields: CreateTicketFormFields;
  public objBatchTicket:SaveBatchTicket;
  showLoader: boolean = false;
  showPaginator: boolean = false;
  public showEquipmentList: boolean = false;
  public isVisibleNextButton:boolean=true;
  public workTypeText:string='';
  equipParams: any = {
    facilityMasterId: 1,
    searchTerm: '',
    equipmentStatusId: 1,
    equipmentTypeId: 1,
    equipmentSubTypeId: null,
    modelId: null


  };
  constructor(private _equipmentService: EquipmentService, private _ticketsService: TicketsService,private _messageService:MessageService) {
    this.formFields = new CreateTicketFormFields();

  }

  ngOnInit() {
    this._ticketsService.getTicketGlobalData().subscribe((Result: any) => {
      this.formFields = Result;
    },
      (respose: Response) => {
        // handle error here
      }
    );
    this.FacilityEquipmentColumns = [
      { field: 'EquipmentID', header: 'Equipment ID', display: 'none' },
      { field: 'EquipmentTypeDescription', header: 'Equipment Type' },
      { field: 'ManufacturerName', header: 'Manufacturer' },
      { field: 'modelNumber', header: 'Model' },
      { field: 'EquipmentSubTypeDescription', header: 'Sub-Type' },
      { field: 'EquipmentSerialNumber', header: 'Serial#' },
      { field: 'equipmentDescription', header: 'Description' },
      { field: 'hasClockText', header: 'Has Clock' },
    ];

    this.selectedColumns = [
      { field: 'EquipmentTypeDescription', header: 'Equipment Type' },
      { field: 'ManufacturerName', header: 'Manufacturer' },
      { field: 'modelNumber', header: 'Model' },
      { field: 'EquipmentSubTypeDescription', header: 'Sub-Type' },
      { field: 'EquipmentSerialNumber', header: 'Serial#' },
      { field: 'equipmentDescription', header: 'Description' },

    ]
  }
  public getBatchFacilityEquipment() {
    this.showLoader = true;
    this.formFields.showCurrentTemplate = false;
    this.equipParams.facilityMasterId = this.formFields.selectedFacilityId;
    this.equipParams.equipmentTypeId = this.formFields.batchDetails.EquipmentTypeId;
    this.equipParams.equipmentSubTypeId = this.formFields.batchDetails.EquipmentSubTypeId;
    this.equipParams.modelId = this.formFields.batchDetails.ModelId;
    var GETFACILITYEQUIPMENT = this.equipParams;
    this._equipmentService.getFacilityEquipment(JSON.stringify({ GETFACILITYEQUIPMENT })).subscribe((Result: any) => {
      
      //Bart enhancement 2020 - Remove qouates from start ane end EquipmentSerialNumber(SPR-1402) -- starts here
      Result.facilityEquipment.forEach(function(item, i) {  Result.facilityEquipment[i].EquipmentSerialNumber = Result.facilityEquipment[i].EquipmentSerialNumber.replace(/"/g, '');});
      //Bart enhancement 2020 - Remove qouates from start ane end EquipmentSerialNumber (SPR-1402)-- ends here

     this.formFields.selectedBatchEquipmentData=[];
      this.FacilityEquipmentData = Result.facilityEquipment; 
      this.showLoader = false;  
      if (this.FacilityEquipmentData.length <= 0) {
        this._messageService.showAlertMessage("No equipment found for this location");
        this.showEquipmentList = false;
        this.showPaginator=false;
      }
      else{
        this.showEquipmentList = true;
      }
      if(this.FacilityEquipmentData.length>10)
      {
        this.showPaginator=true;
      }
      else{this.showPaginator=false;}
      this.formFields.selectedBatchEquipmentList = [];
    },
      (error) => {
        this.showLoader = false;

      }
    );
  }
  public OnEquipmentRowClick(rowId) {
    if (this.formFields.selectedBatchEquipmentList.length <= 0) {
      this.formFields.selectedBatchEquipmentList = []
    }
    this.formFields.selectedBatchEquipmentList.push(this.formFields.selectedBatchEquipmentData)
    this.formFields.selectedBatchEquipmentList = this.formFields.selectedBatchEquipmentList.filter(
      (thing, i, arr) => arr.findIndex(t => t.EquipmentID === thing.EquipmentID) === i
    );
    this.isVisibleNextButton=true;
  }
  public RemoveSelectedEquipment(rowId) {
    let rowDetails = this.formFields.selectedBatchEquipmentList[rowId]
    if (rowDetails != null) {
      let temequipmentId = rowDetails["EquipmentID"];
      this.formFields.selectedBatchEquipmentList = this.formFields.selectedBatchEquipmentList.filter(x => x.EquipmentID != temequipmentId);
      if (this.formFields.selectedBatchEquipmentList.length <= 0) {
        this.formFields.selectedBatchEquipmentList = []
        this.formFields.isShowBatchLabour=false;
        this.formFields.selectedBatchEquipmentData=this.formFields.selectedBatchEquipmentList;
      }
       if(this.formFields.selectedBatchEquipmentData["EquipmentID"]== temequipmentId)
       {
        this.formFields.selectedBatchEquipmentData=[];
       }
    }

  }
  public onRowUnselect()
  {
    this.formFields.selectedBatchEquipmentList=this.formFields.selectedBatchEquipmentData;
  }
  public selectNextBatchForm() {
    this.workTypeText =this.formFields.selectedWorkTypeName.toString().toLowerCase();
    if(this.formFields.selectedBatchEquipmentList.length>0)
    {
      if(this.workTypeText=='software versioning' || 
         this.workTypeText=='attestation' 
         || this.workTypeText=='water volume' 
         || this.workTypeText=='volume template' 
         || this.workTypeText=='water duration' 
         || this.workTypeText=='water frequency'
         || this.workTypeText=='water volume monthly' 
         || this.workTypeText=='volume temperature template'
         || this.workTypeText=='network survey'
         || this.workTypeText=='electrical safety' )
      {
        this.formFields.showCurrentTemplate = true;
        this.filteredBatchEquipments=null//Clear the filter Record when open template 
      }
     else{
      this.formFields.showCurrentTemplate = false;
      this.formFields.isBatchTicket=true;
      this.formFields.batchTicketObj=[]     
      for(let obj of this.formFields.selectedBatchEquipmentList){
        this.objBatchTicket=new SaveBatchTicket();
        this.objBatchTicket.equipmentId=obj.EquipmentID
        this.formFields.batchTicketObj.push(this.objBatchTicket);
      }
      this.isVisibleNextButton=false;
      this.formFields.isShowBatchLabour=true;
     }
      this._ticketsService.setTicketGlobalData(this.formFields);  
      
  }
  else{
    this._messageService.showAlertMessage("Plaese select equipment to continue.");
  }

  }
  public selectall()
  {
    if(this.filteredBatchEquipments==null)
    {
      this.filteredBatchEquipments=this.FacilityEquipmentData;
    }
    //this.formFields.selectedBatchEquipmentList=[];
    this.filteredBatchEquipments.forEach(x=>{
      this.formFields.selectedBatchEquipmentList.push(x);
    })
    this.formFields.selectedBatchEquipmentList = this.formFields.selectedBatchEquipmentList.filter(
      (thing, i, arr) => arr.findIndex(t => t.EquipmentID === thing.EquipmentID) === i
    );
    this._messageService.showAlertMessage(this.filteredBatchEquipments.length+" rows added")
  }
  public filteredBatchEquipments:any[]=null
  getFilteredEquipment(event: any) 
  {
    this.filteredBatchEquipments=event.filteredValue; // applied filters
  }
}
